import morphism, { createSchema } from 'morphism';
import { schemaImage } from '../components/schemaImage';
import { schemaDatoButton } from '../schemaDatoButton';

export const schemaCardsGrid = createSchema<any>({
  title: 'title',
  subtitle: 'cardsGridSubtitle',
  headingAlignment: 'headingAlignment',
  cardsDesign: 'cardsDesign',
  cards: {
    path: ['cards', 'pixelDensity', 'locale'],
    fn: ({ cards, pixelDensity, locale }: any) => {
      return cards.map((card: any) => ({
        title: card.title,
        subtitle: card.subtitle,
        image: morphism(schemaImage, { ...card.image, pixelDensity }),
        cta: card.cta?.map((ctaItem: any) => {
          let cta;
          if (ctaItem) {
            cta = morphism(schemaDatoButton, {
              ...ctaItem,
              locale,
            });
          }
          return cta;
        }),
      }));
    },
  },
});
